import type { ProductPromotion } from '../types';

const guestOnlyPromos = 'Sign In';

export const isUserEligibleForPromo = (promo: ProductPromotion, isAuthenticated: boolean) => {
    const message = promo.callout_msg;

    return isAuthenticated ? !message.toLowerCase().includes(guestOnlyPromos.toLowerCase()) : !!message;
};
